import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { Testimonios } from './components/Testimonios';
import { Problema } from './components/Problema';
import { Metodo } from './components/Metodo';
import { QueIncluye } from './components/QueIncluye';
import { Bonos } from './components/Bonos';
import { Transformacion } from './components/Transformacion';
import { Oferta } from './components/Oferta';
import { Comparacion } from './components/Comparacion';
import { Garantia } from './components/Garantia';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-padel-dark text-white selection:bg-neon selection:text-black font-sans" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <CountdownBar data-id="element-2" />
      {/* Spacer for fixed countdown bar */}
      <div className="h-8" data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <Testimonios data-id="element-6" />
        <Problema data-id="element-7" />
        <Metodo data-id="element-8" />
        <QueIncluye data-id="element-9" />
        <Bonos data-id="element-10" />
        <Transformacion data-id="element-11" />
        <Oferta data-id="element-12" />
        <Comparacion data-id="element-13" />
        <Garantia data-id="element-14" />
        <FAQ data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}